export default __webpack_public_path__ + "media/images/features/yado/sample_img_1-519bcbd125d46b8862bd1d64dd33af22.jpg";